export default __webpack_public_path__ + "static/media/herded-sheep.d4d74e32.svg";